import React, { useEffect, useState } from 'react';

import s from './Spinner.module.scss';

interface SpinnerProps {
  delay?: number;
  isFixed?: boolean;
}

export const Spinner = ({
  delay,
  isFixed = true,
}: SpinnerProps): JSX.Element | null => {
  const isDelay = Number.isFinite(delay);
  const [isVisible, setIsVisible] = useState(!isDelay);

  useEffect(() => {
    let timeoutId: any = undefined;
    if (isDelay) {
      timeoutId = setTimeout(() => setIsVisible(true), delay);
    }

    return () => clearTimeout(timeoutId);
  }, [delay, isDelay]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={isFixed ? s.spinnerContainer : s.spinnerContainerRelative}>
      <div className={s.spinner}>
        <div className={s.spinner__wheel} />
      </div>
    </div>
  );
};
